export { default as logo } from './icons/logo.png';
export { default as Iconhome } from './icons/home_icon.png';
export { default as deleteIcon} from './icons/delete.svg';
export { default as editIcon } from './icons/edit.svg';
export { default as downarrow } from './icons/down_arrow.png';
export { default as dragIcon } from './icons/dragIcon.svg';


